import { Button, Modal, Form, Input, Upload, message, InputNumber } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { MyValidateMessages } from "../../../../utils/validateMessaage";
import { postNewContact } from "../../../../api/api";
import UploadOnePicture from "../../../../components/upLoadOnePicture/uploadPicture";

export default function NewContact(props) {
  //表单设置
  const { TextArea } = Input;
  const [componentDisabled, setComponentDisabled] = useState(false);
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled);
  };
  const [form] = Form.useForm();
  const [total, setTotal] = useState(props.total);

  //modal设置
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const { setFresh } = props

  const handleOk = (e) => {
    form.setFieldValue("image", url);
    form.validateFields().then((res) => {
      postNewContact(res).then((res) => {
        console.log(res);
        setFresh((pre) => {
          return !pre;
        });
        setTotal(total + 1);
        message.success("新建联系人成功！");
        form.resetFields();
        setOpen(false);
      });
    });
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  //向父组件传递图片网址
  const [url, setUrl] = useState();
  const setImgUrl = (url) => {
    setUrl(url);
    // console.log(url);
  };

  return (
    <>
      <Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
        新建
      </Button>
      <Modal
        title="新建联系人"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Form
          validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
        >
          <Form.Item
            label="描述"
            name="description"
            rules={[
              {
                required: true,
                max: 20,
              },
            ]}
          >
            <TextArea rows={2} placeholder="请输入联系人的描述，上限20字" />
          </Form.Item>

          <Form.Item
            label="联系人图片"
            valuePropName="image"
            name="image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture deliverUrl={setImgUrl} image={null ?? ''} />
          </Form.Item>

          <Form.Item
            label="推荐权重"
            name="weight"
            rules={[
              {
                type: 'number',
                required: true,
                max: 100,
                min: 0,
              },
            ]}
          >
            <InputNumber
              style={{ width: '18vw' }}
              placeholder="请输入0-100的的数字"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
